import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { StageService } from '../proxy/controlling/controllers/stage.service';
import { ActivityService } from '../proxy/controlling/controllers/activity.service';

FieldBuilder.setNamespace('Controlling');

export const ACTIVITYPERSTAGE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('stageId', 'Entity.Stage', StageService)
    .required()
    .displayFromNested('stage.name')
    .sortBy('stage.name')
    .build(),
  FieldBuilder
    .foreignKey('activityId', 'Entity.Activity', ActivityService)
    .required()
    .displayFromNested('activity.name')
    .sortBy('activity.name')
    .hideInChildForms()
    .build(),
];

export const ACTIVITYPERSTAGE_CONFIG = {
  entityName: 'ActivityPerStage',
  localizationKey: 'Controlling::Entity.ActivityPerStage',
  fields: ACTIVITYPERSTAGE_FIELDS,
  permission: 'ControllingActivities.ActivityPerStages',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
